var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'message-abstract-text',
    `message-abstract-text-${_vm.highlightType}`,
    `message-abstract-text-${_vm.displayType}`,
  ]},_vm._l((_setup.contentText),function(contentItem,index){return _c('span',{key:index,class:[(contentItem && contentItem.isHighlight) ? 'highlight' : 'normal']},[_vm._v(" "+_vm._s(contentItem.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }